import { Route, Routes } from "react-router";
import Home from "./views/Home";
import { NotificationContainer } from "react-notifications";
import "react-notifications/lib/notifications.css";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
      <NotificationContainer />
    </div>
  );
}

export default App;
